import { isNullable } from '@app/utils'

import type { Column, ColumnGroup } from '@app/components/base/Table/types'

export const isColumnGroup = <ColumnType>(column: Column<ColumnType>): column is ColumnGroup<ColumnType> => {
  return !isNullable((column as ColumnGroup<unknown>)?.children)
}
